'use client';

import Button from 'molecules/Button';
import Image from 'molecules/Image';
import Lightbox from 'molecules/Lightbox';
import WistiaVideoPlayer from 'molecules/Video';

import styles from 'components/Heros/LightboxHero/lightbox-hero.module.scss';

import { isNonEmptyArray } from 'utils/functions';

import type { LightboxHeroProps } from 'components/Heros/LightboxHero/config';
import type { FC } from 'react';

const LightboxHero: FC<LightboxHeroProps> = ({
  heading,
  subhead,
  cta,
  embed,
  statHeading,
  stats,
  thumbnailImage,
  icon,
}) => (
  <div className={styles.lightboxHero}>
    <div className={styles.lightboxHeroWrapper}>
      {heading && <h1 className={styles.lightboxHeroTitle}>{heading}</h1>}
      {subhead && <span className={styles.lightboxHeroTeaser}>{subhead}</span>}
      {cta?.label && cta?.link && (
        <Button color="teal" textStyle="upper" url={cta?.link}>
          {cta?.label}
        </Button>
      )}
      <Lightbox
        classes={{
          link: styles.trigger,
          closeButton: styles.closeButton,
        }}
        modalContent={
          <div className={styles.videoWrapper}>
            <WistiaVideoPlayer embed={embed} />
          </div>
        }
      >
        {thumbnailImage && thumbnailImage?.url && (
          <Image
            url={thumbnailImage.url}
            width={thumbnailImage?.width}
            height={thumbnailImage?.height}
            alt="watch the video"
            priority
          />
        )}
        {icon && (
          <div className={styles.playButton}>
            <Image url={icon.url} width={icon?.width} height={icon?.height} alt="watch the video" />
          </div>
        )}
      </Lightbox>
      {statHeading && <p className={styles.lightboxHeroBlurb}>{statHeading}</p>}
      {isNonEmptyArray(stats) && (
        <ul className={styles.lightboxHeroBenefits}>
          {stats.map((stat, index) => (
            <li key={`benefit-${index}`}>{stat?.stat}</li>
          ))}
        </ul>
      )}
    </div>
  </div>
);

export default LightboxHero;
